export enum EnvironmentType {
  Dev = 0,
  SIT = 1,
  UAT = 2,
  Staging = 3,
  Production = 4,
}

export enum ApplipcationStoreType {
  Peak = 0,
  NewPeak = 1,
  Payroll = 2,
  Board = 3,
  Asset = 4,
  Tax = 5,
}

export enum LoadingStatusType {
  None = 0,
  Loading = 1,
  Success = 2,
  Fail = 3,
}

export enum Language {
  None = 0,
  Thai = 1,
  English = 2,
}

export enum ExcludedAccountCodeFromCreate {
  Cash = 111101,
  CurrentAccounts = 111201,
  SavingAccounts = 111301,
  UncashedCheques = 111401,
  FixedDeposites = 112101,
  AccountsReceivable = 113101,
  ChequesReceivedInAdvance = 113102,
  AccountsPayable = 212101,
  ChequesPayable = 212102,
}

export enum ParamsReloadType {
  Reload = 1,
  IsMain = 2,
}

export enum ActionType {
  Create = 1,
  Edit = 2,
}

export enum ActivityLogActionType {
  SignIn = 1,
  SignOut = 2,
  ViewErrorPage = 3,
  SelectMerchant = 4,
  ViewIncomePage = 5,
  ViewQuotationTable = 6,
  SearchQuotationTable = 7,
  AdvanceSearchQuotationTable = 8,
  ViewCreateQuotation = 9,
  ViewCreateMerchant = 10,
  CreateMerchant = 11,
  CreateDemoMerchant = 12,
  ViewSelectList = 13,
  Register = 14,
  ResetPassword = 15,
  ForgotPassword = 16,
  RegisterWithInvitation = 17,
  ViewQuotationDetail = 18,
  CreateQuotation = 19,
  EditQuotation = 20,
  SendQuotationEmail = 21,
  ApproveQuotation = 22,
  AcceptQuotation = 23,
  SubmitDraftQuotation = 24,
  ViewInvoiceTable = 25,
  SearchInvoiceTable = 26,
  AdvanceSearchInvoiceTable = 27,
  ViewCreateInvoice = 28,
  ViewInvoiceDetail = 29,
  CreateInvoice = 30,
  EditInvoice = 31,
  PaidPayment = 32,
  SubmitDraftInvoice = 33,
  ApproveInvoice = 34,
  SendInvoiceEmail = 35,
  ViewReceiptTable = 36,
  SearchReceiptTable = 37,
  AdvanceSearchReceiptTable = 38,
  ViewCreateReceipt = 39,
  ViewReceiptDetail = 40,
  CreateReceipt = 41,
  EditReceipt = 42,
  SubmitDraftReceipt = 43,
  ApproveReceipt = 44,
  SendReceiptEmail = 45,
  ViewTaxInvoiceTable = 46,
  SearchTaxInvoiceTable = 47,
  AdvanceSearchTaxInvoiceTable = 48,
  ViewCreateTaxInvoice = 49,
  ViewTaxInvoiceDetail = 50,
  CreateTaxInvoice = 51,
  EditTaxInvoice = 52,
  SubmitDraftTaxInvoice = 53,
  ApproveTaxInvoice = 54,
  SendTaxInvoiceEmail = 55,
  UploadQuotation = 56,
  UploadInvoice = 57,
  UploadReceipt = 58,
  ArchiveIncomeTransaction = 59,
  UnarchiveIncomeTransaction = 60,
  VoidIncomeTransaction = 61,
  CreateProduct = 62,
  CreateContact = 63,
  ExportQuotationExcel = 64,
  ExportInvoiceExcel = 65,
  ExportReceiptExcel = 66,
  ExportTaxinvoiceExcel = 67,
  ViewExpensePage = 68,
  ViewPoTable = 69,
  SearchPoTable = 70,
  AdvanceSearchPoTable = 71,
  ViewCreatePo = 72,
  ViewPoDetail = 73,
  CreatePo = 74,
  EditPo = 75,
  ApprovePo = 76,
  SendPoEmail = 77,
  AcceptPo = 78,
  SubmitDraftPo = 79,
  ViewExpenseTable = 80,
  SearchExpenseTable = 81,
  AdvanceSearchExpenseTable = 82,
  ViewCreateExpense = 83,
  ViewExpenseDetail = 84,
  CreateExpense = 85,
  EditExpense = 86,
  ReceiveExpense = 87,
  PaidExpense = 88,
  SubmitDraftExpense = 89,
  ApproveExpense = 90,
  SendExpenseEmail = 91,
  ViewExpenseTaxInvoiceTable = 92,
  SearchExpenseTaxInvoiceTable = 93,
  AdvanceSearchExpenseTaxInvoiceTable = 94,
  ViewCreateExpenseTaxInvoice = 95,
  ViewExpenseTaxInvoiceDetail = 96,
  CreateExpenseTaxInvoice = 97,
  ApproveExpenseTaxInvoice = 98,
  SubmitDraftExpenseTaxInvoice = 99,
  ReceiveExpenseTaxInvoice = 100,
  SendExpenseEmailTaxInvoice = 101,
  UploadPo = 102,
  UploadExpense = 103,
  ArchiveExpenseTransaction = 104,
  UnarchiveExpenseTransaction = 105,
  VoidExpenseTransaction = 106,
  ExportPoExcel = 107,
  ExportExpenseExcel = 108,
  ExportExpenseTaxInvoiceExcel = 109,
  ViewFinancePage = 110,
  ViewCashPage = 111,
  ViewBankPage = 112,
  ViewAdvancePage = 113,
  ViewTaxedPage = 114,
  ViewTaxPage = 115,
  ViewFinanceDetailPage = 116,
  CreateBankaccount = 117,
  EditBankaccount = 118,
  EditTransferPayment = 119,
  ViewContactTable = 120,
  ViewContactDetail = 121,
  ViewEditContact = 122,
  EditContact = 123,
  SearchContactTable = 124,
  ViewCreateContactPage = 125,
  CreateContactFormCreatePage = 126,
  CreateContactGroup = 127,
  AddContactsToGroup = 128,
  ImportContacts = 129,
  ArchiveContacts = 130,
  UnarchiveContacts = 131,
  DeleteContactGroup = 132,
  ViewProductTable = 133,
  ViewProductDetail = 134,
  SearchProductTable = 135,
  EditProduct = 136,
  DeleteProduct = 137,
  ImportProducts = 138,
  AdjustProductNumber = 139,
  ViewSettingPage = 140,
  ViewUserSettingPage = 141,
  SearchUserTable = 142,
  ViewAddTeamPage = 143,
  ViewInvitationPage = 144,
  ViewUserrolePage = 145,
  ViewOrganizationPage = 146,
  UploadMerchantLogo = 147,
  EditMerchantProfile = 148,
  EditUserrole = 149,
  InviteFriend = 150,
  AddTeam = 151,
  ViewProfilePage = 152,
  ViewChangePasswordPage = 153,
  UploadProfileLogo = 154,
  EditUserProfile = 155,
  ChangeProfilePassword = 156,
  ViewOnlineViewPage = 157,
  ChangeContactGroupName = 158,
  DeleteBankAccount = 159,
  VoidInvoicePayment = 160,
  ViewDailyJournalTable = 161,
  ViewCreateDailyJournal = 162,
  CreateDailyJournal = 163,
  EditDailyJournal = 164,
  SearchDailyJournalTable = 165,
  VoidDailyJournal = 166,
  ApproveDailyJournal = 167,
  ExportDailyJournal = 168,
  ViewDailyJournalDetail = 169,
  ViewDailyJournalOnlineView = 170,
  ReRecordJournal = 171,
  ViewCreditNoteDetail = 173,
  CreateCreditNote = 174,
  UploadCreditNote = 175,
  SendCreditNoteEmail = 176,
  ViewReceiveCreditNoteDetail = 177,
  CreateReceiveCreditNote = 178,
  ViewBillingNoteDetail = 179,
  CreateBillingNote = 180,
  SendBillingNoteEmail = 181,
  EditBillingNote = 182,
  UploadBillingNote = 183,
  SubmitDraftBillingNote = 184,
  ApproveBillingNote = 185,
  ViewCombinedPaymentNoteDetail = 186,
  CreateCombinedPaymentNote = 187,
  SendCombinedPaymentNoteEmail = 188,
  EditCombinedPaymentNote = 189,
  ViewPP30Table = 190,
  ViewCreatePP30 = 191,
  CreatePP30 = 192,
  VoidPP30 = 193,
  ViewPP30Detail = 194,
  ViewOnlineViewPP30 = 195,
  EditPurchaseTaxInvoiceRefNumberAndDate = 196,
  EditReceivedCreditNoteNumberAndDate = 197,
  DraftQuotation = 198,
  SendForApproveQuotation = 199,
  DraftInvoice = 200,
  SendForApproveInvoice = 201,
  DraftReceipt = 202,
  SendForApproveReceipt = 203,
  DraftTaxInvoice = 204,
  SendForApproveTaxInvoice = 205,
  DraftPo = 206,
  SendForApprovePo = 207,
  DraftExpense = 208,
  SendForApproveExpense = 209,
  CreatePP30TextFile = 210,
  EditDocumentQuotation = 211,
  DeleteUser = 212,
  EditPaymentInvoice = 213,
  EditPaymentExpense = 214,
  EditPaymentBillingNote = 215,
  EditPaymentCombinePaymentNote = 216,
  EditPaymentCreditNote = 217,
  EditPaymentReceivedCreditNote = 218,
  EditPaymentReceipt = 219,
  SettingEmailReport = 220,
  RecalculateCostOfGoodSold = 221,
  ViewPnd53Table = 222,
  ViewCreatePnd53 = 223,
  CreatePnd53 = 224,
  ViewPnd53Detail = 225,
  UpdateStatusPnd53 = 226,
  VoidPnd53 = 227,
  VoidPnd53Payment = 228,
  ViewOnlineViewPnd53 = 229,
  ViewOnlineViewPnd53FromDetail = 230,
  ViewOnlineViewPnd53FromTextFile = 231,
  VoidPP30Payment = 232,
  CreatePP30VatItemReport = 233,
  ViewPnd3Table = 234,
  ViewCreatePnd3 = 235,
  CreatePnd3 = 236,
  ViewPnd3Detail = 237,
  VoidPnd3 = 238,
  UpdateStatusPnd3 = 239,
  VoidPnd3Payment = 240,
  ViewOnlineViewPnd3FromTextFile = 241,
  ViewOnlineViewPnd3 = 242,
  ViewOnlineViewPnd3FromDetail = 243,
  AttachFile = 244,
  RemoveFile = 245,
  ArchiveProducts = 246,
  UnarchiveProducts = 247,
  ViewCreditNoteTable = 248,
  ViewReceivedCreditNoteTable = 249,
  ExportCreditNoteExcel = 250,
  ExportReceivedCreditNoteExcel = 251,
  ExportBillingNoteExcel = 252,
  ExportCombinePaymentNoteExcel = 253,
  SearchCreditNoteTable = 254,
  SearchReceivedCreditNoteTable = 255,
  ViewBillingNoteTable = 256,
  ViewCombinePaymentNoteTable = 257,
  SearchBillingNoteTable = 258,
  SearchCombinePaymentNoteTable = 259,
  ViewOnlineViewCover = 260,
  EditReferenceNameCreditNote = 261,
  SendEtaxInvoiceByEmail = 262,
  SendEtaxInvoiceByBlockChain = 263,
  ReSendReferFriend = 264,
  UpdateReferFriendStatusCaseReSendEmail = 265,
  UpdateReferFriendStatusCaseRegistered = 266,
  UpdateReferFriendStatusCaseCreateMerchant = 267,
  UpdateReferrerPromotionCodeId = 268,
  SendPromotionCodeToReferrer = 269,
  ViewDebitNoteTable = 270,
  ViewCreateDebitNote = 271,
  ViewDebitNoteDetail = 272,
  CreateDebitNote = 273,
  DoRecurringTransaction = 274,
  RegisTerWithheldtaxFromCustomer = 275,
  VoidRegisTerWithheldtaxFromCustomer = 276,
  ReceiveWithholdingToSupplier = 277,
  VoidReceiveWithholdingToSupplier = 278,
  RequestVerifyOrganization = 279,
  UpdateJournalStatusAwaitRecord = 280,
  SendEtaxInvoiceByINet = 281,
  StopCalculateAssetDepreciation = 282,
  CreateChartOfAccount = 283,
  AttachFileWhtPuunReceipt = 284,
  SendApproveBillingNote = 285,
  SendWhtCertificateEmail = 286,
  UploadProfileSignature = 287,
  RegisterTaxInvoice = 288,
  VoidRegisterTaxInvoice = 289,
  DeleteChartOfAccount = 290,
  UpdateChartOfAccount = 291,
  ImportQuotation = 292,
  ImportPurchaseOrder = 293,
  ImportInvoice = 294,
  ImportExpense = 295,
  ImportReceipt = 296,
  ImportReceiptFromInvoice = 297,
  ImportReceiptFromQuotation = 298,
  ImportInvoiceFromQuotation = 299,
  ImportJournal = 300,
  UpdateUnit = 301,
  DeleteUnit = 302,
  EditCheque = 303,
  ReceivedCheque = 304,
  EditCreditNote = 305,
  DraftCreditNote = 306,
  SendForApproveCreditNote = 307,
  ApproveCreditNote = 308,
  DraftDebitNote = 309,
  EditDebitNote = 310,
  SendForApproveDebitNote = 311,
  ApproveDebitNote = 312,
  CreateReceiveDebitNote = 313,
  UploadDebitNote = 314,
  SendDebitNoteEmail = 315,
  EditPaymentDebitNote = 316,
  EditReferenceNameDebitNote = 317,
  ViewReceiveDebitNoteTable = 318,
  ViewReceiveCreateDebitNote = 319,
  ViewReceiveDebitNoteDetail = 320,
  EditPaymentReceiveDebitNote = 321,
  UploadReceiveDebitNote = 322,
  SendReceiveDebitNoteEmail = 323,
  EditReceiveDebitNote = 324,
  CannotGotReceipt = 325,
  CreateRecurringInvoice = 326,
  EditRecurringInvoice = 327,
  VoidRecurringInvoice = 328,
  ViewRecurringInvoice = 329,
  EnableRecurringInvoice = 330,
  DisableRecurringInvoice = 331,
  CreateRecurringExpense = 332,
  EditRecurringExpense = 333,
  VoidRecurringExpense = 334,
  ViewRecurringExpense = 335,
  EnableRecurringExpense = 336,
  DisableRecurringExpense = 337,
  CreateRecurringReceipt = 338,
  EditRecurringReceipt = 339,
  VoidRecurringReceipt = 340,
  ViewRecurringReceipt = 341,
  EnableRecurringReceipt = 342,
  DisableRecurringReceipt = 343,
  RejectTransaction = 344,
  DownloadUserManaulPdf = 345,
  UpdateQRPaymentSettingMerchant = 346,
  EditRemark = 347,
  EditDueDate = 348,
  EditReferenceName = 349,
  EditProductAccoundAndDescription = 350,
  EditTransactionNumber = 351,
  EditTransactionContact = 352,
  OmiseAddCard = 353,
  OmiseUpdateCard = 354,
  OmiseRemoveCard = 355,
  EditTransactionPaymentDate = 356,
  EditTransactionDate = 357,
  EditWhtTransactionItem = 358,
  DeleteMerchant = 359,
  DraftDailyJournal = 360,
  DownloadAccountantManualPdf = 361,
  SendApproveJournal = 362,
  EditClassification = 363,
}

export enum TableSorting {
  DESC = 0,
  ASC = 1,
}
export enum ModalType {
  Basic = 1,
  Advance = 2,
}
export enum Locales {
  EN = "en",
  TH = "th",
}
export enum LanguageType {
  Th = 0,
  En = 1,
}
export enum RevenueDeductType {
  Revenue = 0,
  Deduction = 1,
}

export enum OrdinaryPersonPrefixType {
  None = 0,
  Sir = 1,
  Mr = 2,
  Mrs = 3,
  Ms = 4,
  Other = 5,
}

export enum TypeComponentNoti {
  success = 1,
  warn = 2,
  error = 3,
  upload = 4,
}

export enum IdentifyPersionType {
  CitizenId = 0,
  Passport = 1,
}
export enum PrompPayType {
  Phone = 0,
  CitizenId = 1,
}
export enum FinanceChanelType {
  Cash = 0,
  Bank = 1,
  PrompPay = 2,
}
export enum EmployeeOrderType {
  None = 0,
  Id = 1,
  Code = 2,
  Name = 3,
  Department = 4,
  Salary = 5,
}
export enum EmployeeContactType {
  Monthly = 0,
  Daily = 1,
}
export enum BankType {
  None = 0,
  CurrentAccount = 1,
  SavingAccount = 2,
  FixedDeposit = 3,
}

export enum PndType {
  None = 0,
  PND1 = 1,
  PND2Specialkor = 2,
  PND2 = 3,
  PND3 = 4,
  PND2kor = 5,
  PND3kor = 6,
  PND53 = 7,
  PND54 = 8,
}

export enum FilingCaseType {
  None = 0,
  M3Sec3 = 1, //ม.3 เตรส
  M65Sec4 = 2, //ม.65 จัตวา
  M69Sec2 = 3, //ม.69 ทวิ
  M48Sec2 = 4, //M.48 ทวิ
  M50 = 5, //ม. 50(3)(4)(5)
}

export enum FilingType {
  None = 0,
  Normal = 1,
  More = 2,
}

export enum DepartmentType {
  None = 0,
  GeneralManagement = 1,
  GeneralAdministration = 2,
  Sales = 3,
  Marketing = 4,
  Accounting = 5,
  Finance = 6,
  HumanResource = 7,
  Production = 8,
  Operation = 9,
  InformationTechnology = 10,
  Purchasing = 11,
  ResearchAndDevelopment = 12,
  Other = 13,
}

export enum TypeComponentNoti {
  Success = 1,
  Warn = 2,
  Error = 3,
  Upload = 4,
}

export enum DepartmentOrderType {
  None = 0,
  Id = 1,
  Code = 2,
  Name = 3,
  Archived = 4,
  Account = 5,
}

export enum EmployeeHistoryOrderType {
  Name = 1,
  Date = 2,
}

export enum RevenueDeductOrderType {
  None = 0,
  Type = 1,
  Code = 2,
  Name = 3,
  CalculateAnnualRevenue = 5,
  Archived = 6,
}

export enum SortingType {
  DESC = 0,
  ASC = 1,
}
export enum DefaultRevenueDeductType {
  Other = 0,
  Salary = 1,
  Commision = 2,
  Overtime = 3,
  Allowance = 4,
  Travel = 5,
  Bonus = 6,
  Position = 7,
  BenefitCostLiving = 8,
  BenefitMobilePhoneExpense = 9,
  BenefitTransporation = 10,
  BenefitHouseRental = 11,
  BenefitFood = 12,
  DiligenAllowance = 13,
  WithHoldingTax = 14,
  SocialSecurityFund = 15,
  ProvidentFund = 16,
  Fine = 17,
  Absence = 18,
  LeaveWithOutPay = 19,
}
export enum DefaultRevenueType {
  Other = 0,
  Salary = 1,
  Commision = 2,
  Overtime = 3,
  Allowance = 4,
  Travel = 5,
  Bonus = 6,
  Position = 7,
  BenefitCostLiving = 8,
  BenefitMobilePhoneExpense = 9,
  BenefitTransporation = 10,
  BenefitHouseRental = 11,
  BenefitFood = 12,
  DiligenAllowance = 13,
}
export enum DefaultDeductType {
  Other = 0,
  WithHoldingTax = 14,
  SocialSecurityFund = 15,
  ProvidentFund = 16,
  Fine = 17,
  Absence = 18,
  LeaveWithOutPay = 19,
}
export enum TaxRevenueCalculationType {
  Include = 0,
  Exclude = 1,
}
export enum SocialSecurityRevenueCalculationType {
  Include = 0,
  Exclude = 1,
}
export enum PositionType {
  Operation = 0,
  Management = 1,
}
export enum PositionOrderType {
  None = 0,
  Id = 1,
  Code = 2,
  Name = 3,
  Archived = 4,
  Account = 5,
}
export enum SalaryStatusType {
  Draft = -2,
  AwaitApprove = -1,
  Approved = 0,
  Paid = 1,
}
export enum BankReferenceType {
  NONE = -1,
  OTHER = 0,
  BBL = 1,
  KBANK = 2,
  SCB = 3,
  SME = 4,
  KTB = 5,
  BAY = 6,
  KK = 7,
  CIMB = 8,
  TMB = 9,
  TISCO = 10,
  TCR = 11,
  TCAP = 12,
  BAAC = 13,
  EXIM = 14,
  UOB = 15,
  LHBANK = 16,
  SCBT = 17,
  GSB = 18,
  IBANK = 20,
  ICBC = 21,
  JPMORGAN = 22,
  CITIBANK = 23,
  SMBC = 24,
  DB = 25,
  BNP = 26,
  MIZUHO = 27,
  THAIPR = 28,
  BOC = 29,
  BOA = 30,
  RBS = 31,
  RHB = 32,
  IOB = 33,
  HSBC = 34,
  ANZ = 35,
  OCBC = 36,
  GHBANK = 37,
}
export enum SalaryOrderType {
  None = 0,
  Id = 1,
  Number = 2,
  IssuedDate = 3,
  EmployeeCount = 4,
  PaymentDate = 5,
  NetAmount = 6,
}
export enum SalaryTableStatusType {
  All = 0,
  Draft = 1,
  AwaitApprove = 2,
  Approved = 3,
  Paid = 4,
  Void = 5,
}

export enum IssuedPeakAccountStatusType {
  None = 0,
  IssuedWhenCreatedSalary = 1,
  IssuedWhenPaidPayment = 2,
}
export enum BankAccountType {
  Cash = 0,
  Bank = 1,
  ExpenseClaim = 2,
  WithheldTax = 3,
  WithholdingTax = 4,
  EWallet = 5,
}
export enum OnBoardingType {
  None = 0,
  ViewSetting = 1,
  ViewDepartment = 2,
  ViewEmployee = 3,
  ViewRevenueDeduct = 4,
  ViewPayrun = 5,
}

export enum TypeOfPerson {
  OrdinaryPerson = 1,
  JuristicPerson = 2,
}

export enum MerchantType {
  None = 0,
  LimitedLiabilityPartnership = 1,
  CompanyLimited = 2,
  PublicCompanyLimited = 3,
  Shop = 4,
  OrdinaryPerson = 5,
  BodyOfPersons = 6,
  Others = 7,
  OrdinaryPartnership = 8,
  Foundation = 9, //มูลนิธิ
  Association = 10,
  JointVenture = 11,
}

export enum Role {
  None = 0,
  ViewOnly = 1, // ดูได้อย่างเดียว
  PartialRightsDraftOnly = 2, //สิทธิบางส่วน ร่างได้อย่างเดียว
  PartialRightsApproveAndReceivePayment = 3, //สิทธิบางส่วน อนุมัติและรับจ่าย
  PartialRightsRevenueOnly = 4, //สิทธิบางส่วน ฝั่งรายได้อย่างเดียว
  PartialRightsExpenseOnly = 5, //สิทธิบางส่วน ฝั่งรายจ่ายอย่างเดียว
  PartialRightsQuotationOnly = 6, //สิทธิบางส่วน ใบเสนอราคาอย่างเดียว
  StandardRightsViewReport = 7,
  StandardRightsNotViewReport = 8,
  Admin = 9,
}

export enum PeakPayrollExceptionCode {
  None = 0,
  CodeDuplicated = 1,
  CodeIsEmpty = 2,
  IsHaveEmployee = 3,
  IsHaveSalaryEmployee = 4,
  PasscodeInvalid = 5,
  EmailOrBankAccountNumberDuplicated = 6,
  StatementSlipPasscodeNull = 7,
}

export enum Module {
  None = 0,
  Pnd = 1,
  PP30Form = 2,
  PP30Transaction = 3,
  WhtCertificate = 4,
  Merchant = 5,
}

export enum PndActionType {
  None = 0,
  Create = 1,
  ReadDetail = 2,
  Update = 3,
  Delete = 4,
  UpdateStatus = 5,
  UpdateIsFiled = 6,
  UpdateIsPaid = 7,
  AddComment = 8,
  VoidComment = 9,
  AddFileStorage = 10,
  VoidFileStorage = 11,
  UpdateIsClosingEntry = 12,
  CreateExpenseByIsClosingEntry = 13,
  VoidIsClosingEntryPndExpense = 14,
  VoidIsClosingEntryPndJournal = 15,
  VoidIsFiled = 16,
  VoidIsPaid = 17,
}

export enum WhtCertificateActionType {
  None = 0,
  Create = 1,
  QuickCreate = 2,
  ReadDetail = 3,
  Update = 4,
  Delete = 5,
  UpdateStatus = 6,
  UpdateIsFiled = 7,
  UpdateIsPaid = 8,
  AddComment = 9,
  VoidComment = 10,
  AddFileStorage = 11,
  VoidFileStorage = 12,
  FetchData = 13,
}

export enum PP30TransactionActionType {
  None = 0,
  Create = 1,
  QuickCreate = 2,
  ReadDetail = 3,
  Update = 4,
  Delete = 5,
  UpdateStatus = 6,
  UpdateIsFiled = 7,
  UpdateIsPaid = 8,
  AddComment = 9,
  VoidComment = 10,
  AddFileStorage = 11,
  VoidFileStorage = 12,
  UpdateIsClosingEntry = 13,
  CreateExpenseByIsClosingEntry = 14,
  FetchData = 15,
}

export enum PP30FormActionType {
  None = 0,
  Create = 1,
  QuickCreate = 2,
  ReadDetail = 3,
  Update = 4,
  Delete = 5,
  UpdateStatus = 6,
  UpdateIsFiled = 7,
  UpdateIsPaid = 8,
  AddComment = 9,
  VoidComment = 10,
  AddFileStorage = 11,
  VoidFileStorage = 12,
  UpdateIsClosingEntry = 13,
  CreateExpenseByIsClosingEntry = 14,
  FetchData = 15,
  VoidIsClosingEntryPndExpense = 16,
  VoidIsClosingEntryPndJournal = 17,
  VoidIsFiled = 18,
  VoidIsPaid = 19,
}

export enum DisplayLog {
  None = 0,
  Create = 1,
  QuickCreate = 2,
  ReadDetail = 3,
  Update = 4,
  Delete = 5,
  UpdateStatus = 6,
  UpdateIsFiled = 7,
  UpdateIsPaid = 8,
  AddComment = 9,
  VoidComment = 10,
  AddFileStorage = 11,
  VoidFileStorage = 12,
  UpdateIsClosingEntry = 13,
  CreateExpenseByIsClosingEntry = 14,
  FetchData = 15,
  VoidIsClosingEntryPndExpense = 16,
  VoidIsClosingEntryPndJournal = 17,
  VoidIsFiled = 18,
  VoidIsPaid = 19,
}

export enum CreateDocumentType {
  None = 0,
  Draft = 1,
  Created = 2,
  Approved = 3,
  AwaitApproval = 4,
}

export enum ActionEvent {
  Create = 1,
  ReadDetail = 2,
  Update = 3,
  Delete = 4,
  Approve = 5,
  Print = 6,
  Download = 7,
  Archived = 8,
  ReadTable = 9,
  SuggestCode = 10,
  Import = 11,
  UploadImage = 12,
  DeleteImage = 13,
  ExportPayRun = 14,
  ExportSSOSalary = 15,
  ExportImportTemplatePayRunSalary = 16,
  ExportBankFile = 17,
}

export enum SalarySelectedDateOptionType {
  None = 0,
  ThisMonth = 1,
  BeforeMonth = 2,
  ThisYear = 3,
  BeforeYear = 4,
}

export enum ChangeFormType {
  None = 0,
  DayOnDay = 1,
  WeakOnWeak = 2,
  MonthOnMonth = 3,
  QuarterOnQuarter = 4,
  YearOnYear = 5,
}

export enum SalarySummaryType {
  None = 0,
  GrossSalary = 1,
  Department = 2,
  RevenueDeduct = 3,
  Position = 4,
  Account = 5,
}

export enum EmployeeResignReason {
  BenefitProblems = 0,
  PeopleProblems = 1,
  HealthProblems = 2,
  TravelProblems = 3,
  OrganizationStructureProblems = 4,
  ChangeOfWorkplace = 5,
  FurtherStudy = 6,
  SelfEmployedBusiness = 7,
  ContractTerminated = 8,
  Other = 9,
}

export enum ChartOfAccountPaymentNotDisplayPayment {
  Cash = 111101,
  BankCurrentAccount = 111201,
  BankSavingsAccount = 111301,
  CheckDueButNotDeposited = 111401,
  BankFixedDeposit = 112101,
  OtherTemporaryInvestments = 112201,
  TradeReceivables = 113101,
  CheckInAdvance = 113102,
  Materials = 114101,
  InstantProducts = 114102,
  WorkInProcess = 114103,
  BankOverdrafts = 211101,
  TradePayables = 212101,
  CheckPaid = 212102,
  NonRefundableInterestPayment = 212203,
  Land = 124101,
  ConstructionWork = 124102,
  Building = 124103,
  BuildingRenovation = 124104,
  MachineryAndEquipment = 124105,
  OfficeEquipment = 124106,
  OfficeFurnishings = 124107,
  Vehicle = 124108,
  AccumulatedDepreciationBuilding = 124203,
  AccumulatedDepreciationBuildingImprovements = 124204,
  CumulativeDepreciationMachinery = 124205,
  AccumulatedDepreciationOfficeEquipment = 124206,
  AccumulatedDepreciationOfficeSupplies = 124207,
  AccumulatedDepreciationVehicles = 124208,
  Software = 125101,
  LeaseOrUseOfProperty = 125102,
  OtherIntangibleAssets = 125103,
  AccumulatedAmortizationSoftware = 125201,
  AccumulatedAmortizationLeaseholdOrUseRights = 125202,
  AccumulatedAmortizationOtherIntangibleAssets = 125203,
  DepreciationBuilding = 530703,
  DepreciationBuildingImprovements = 530704,
  DepreciationOfficeEquipment = 530706,
  DepreciationOfficeFurniture = 530707,
  DepreciationVehicles = 530708,
  AmortizationSoftware = 530801,
  AmortizationLeaseholdOrUseOfAssets = 530802,
  AmortizationฯtherIntangibleAssets = 530803,
  DepreciationMachinery = 510102,
  InvestmentInAssociatedCompany = 121102,
  InvestmentsInSubsidiaries = 121103,
  InvestmentsInJointVentures = 121104,
  OtherLongTermInvestments = 121105,
  LongTermLoansToRelatedParties = 122101,
  LongTermLoansToOtherPersons = 122102,
  InvestmentProperty = 123101,
  NonCurrentAssetsHeldForSale = 123201,
}

export enum PaymentType {
  Salary = 1,
  SSO = 2,
}

export enum PaymentInOutFlowType {
  None = 0,
  CashIn = 1,
  CashOut = 2,
}

export enum UserType {
  Email = 0,
  Google = 1,
  Microsoft = 2,
}

export enum Package {
  Trial = 0,
  Free = 1,
  Basic = 2,
  Pro = 3,
  ProPlus = 4,
  AFPFree = 5,
  AFPLedger = 6,
  AFPAccountant = 7,
}

export enum ContactType {
  None = 0,
  Create = 1,
  Edit = 2,
}

export enum PrefixNameType {
  None = 0,
  Khun = 1,
  Mr = 2,
  Mrs = 3,
  Ms = 4,
  Other = 5,
}

export enum CreditLimitType {
  Default = 0,
  Unlimit = 1,
  Custom = 2,
}

export enum AddressType {
  NoAddress = 0,
  Building = 1,
  HomeGroup = 2,
  Other = 3,
}

export enum ContactContryType {
  None = 0,
  Thai = 1,
  Others = 2,
}

export enum BranchCompanyType {
  None = 0,
  Quarter = 1,
  Branch = 2,
}

export enum AddressSource {
  NA = 0,
  RD = 1,
  Corporate = 2,
  SmeLink = 3,
}

export enum VerifiedStatus {
  None = 0,
  Proccessing = 1,
  Success = 2,
}

export enum ContactTableView {
  id = 0,
  code = 1,
  name = 2,
  email = 3,
  accountPayable = 4,
  accountReceivable = 5,
}

export enum ContactTableViewStatusType {
  All = 0,
  Achieved = 1,
  CustomGroup = 2,
  ContactCustomer = 3,
  ContactSeller = 4,
}

export enum FinanceType {
  None = 0,
  InFlow = 1,
  OutFlow = 2,
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  Processing = 102,
  EarlyHints = 103,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultiStatus = 207,
  AlreadyReported = 208,
  IMUsed = 226,
  Ambiguous = 300,
  MultipleChoices = 300,
  Moved = 301,
  MovedPermanently = 301,
  Found = 302,
  Redirect = 302,
  RedirectMethod = 303,
  SeeOther = 303,
  NotModified = 304,
  UseProxy = 305,
  Unused = 306,
  RedirectKeepVerb = 307,
  TemporaryRedirect = 307,
  PermanentRedirect = 308,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  NotAcceptable = 406,
  ProxyAuthenticationRequired = 407,
  RequestTimeout = 408,
  Conflict = 409,
  Gone = 410,
  LengthRequired = 411,
  PreconditionFailed = 412,
  RequestEntityTooLarge = 413,
  RequestUriTooLong = 414,
  UnsupportedMediaType = 415,
  RequestedRangeNotSatisfiable = 416,
  ExpectationFailed = 417,
  MisdirectedRequest = 421,
  UnprocessableEntity = 422,
  Locked = 423,
  FailedDependency = 424,
  UpgradeRequired = 426,
  PreconditionRequired = 428,
  TooManyRequests = 429,
  RequestHeaderFieldsTooLarge = 431,
  UnavailableForLegalReasons = 451,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  HttpVersionNotSupported = 505,
  VariantAlsoNegotiates = 506,
  InsufficientStorage = 507,
  LoopDetected = 508,
  NotExtended = 510,
  NetworkAuthenticationRequired = 511,
}

export enum PeakExceptionResponseCode {
  None = 0,
  TransactionNumberDuplicated = 1,
  ContactNotFound = 2,
  ProductNotFound = 3,
  AccountNotFound = 4,
  LockByPeriod = 5,
  FreePackageOverCreateTransaction = 6,
  ProPlusImportTransaction = 7,
  FullPaymentAmount = 8,
  InputFieldEmptry = 9,
  TransactionIsVoided = 10,
  OverPaid = 11,
  ProductNameAndDescriptionIsDuplicated = 12,
  ProductTemplateCodeIsDuplicated = 13,
  AccountCodeIsDuplicated = 14,
  UnitCodeIsDuplicated = 15,
  BankAccountCodeIsDuplicated = 16,
  ContactCodeIsDuplicated = 17,
  TaxIdIsDuplicated = 18,
  ContactNameIsDuplicated = 19,
  IssuedTaxInvoiceDuplicated = 20,
  PaymentIsDeleted = 21,
  ApprovedTransactionDuplicated = 22,
  AcceptedQuotationDuplicated = 23,
  CanNotVoidInvoiceIsIssuedBillingNote = 24,
  CanNotVoidInvoiceIsIssuedCreditNote = 25,
  CanNotVoidReceiptIsIssuedCreditNote = 26,
  LockByUser = 27,
  LockBySystem = 28,
  LockByIssuedPP30 = 29,
  LockBySendEtaxInvoice = 30,
  CanNotVoidQuotationIsIssuedInvoice = 31,
  CanNotVoidQuotationIsIssuedReceipt = 32,
  CanNotCreateDuplicatedReceiptFromReferenceTransaction = 33,
  IssuedDuplicatedTaxInvoice = 34,
  ReceivedTaxInvoiceVatTotalOverflow = 35,
  ReceivedTaxInvoicePreVatTotalOverflow = 36,
  UserProfileIsAlready = 37,
  EmailPasswordIncorrect = 38,
  ContactIdBelongToMerchant = 39,
  MerchantIsVerified = 40,
  ReceivedTaxInvoiceNumberDuplicated = 41,
  DuplicateNameContactGroup = 42,
  ImportTransactionExceed = 43,
  IsHaveUserInSystem = 44,
  DuplicatedReferFriends = 45,
  DuplicateFileName = 46,
  CanNotVoidInvoiceIsIssuedDebitNote = 47,
  CanNotVoidReceiptIsIssuedDebitNote = 48,
  BankAccountNotFound = 49,
  OverInvitationUser = 50,
  UserAlreadyMerchant = 51,
  MerchantPackageIsNotAddUser = 52,
  CanNotEditSuperUser = 53,
  UserUpdateEqualEditUser = 54,
  CanNotRemoveSuperUser = 55,
  CanNotRemoveUser = 56,
  DuplicatedSettingNumberIndextString = 57,
  AuthorityRoleNotPermission = 58,
  NotHavePermissionUser = 59,
  NotHavePermissionFinance = 60,
  NotHavePermissionPayroll = 61,
  NotHavePermissionPeakBoard = 62,
  ApiPartnerNotFound = 63,
  MerchantIsNotAllowDuplicateContact = 64,
  CanNotDeleteThisFinance = 65,
  CanNotVoidAllocation = 66,
  CanNotVoidAllocationItem = 67,
  CanNotIsArchivedAllocationIncome = 68,
  CanNotIsArchivedAllocationExpense = 69,
  LockByIssuedPND3 = 70,
  LockByIssuedPND53 = 71,
  CanNotEditDocumentIsIssuedFromPayroll = 72,
  CreditLimitCannontCreate = 73,
  CreditLimitWarning = 74,
  CanNotVoidPaymentIsIssuedReceipt = 75,
  InvalidDocumentPassCode = 76,
  CanNotEditInvoiceIsIssuedDebitNote = 77,
  CanNotEditInvoiceIsIssuedCreditNote = 78,
  CanNotEditJournal = 79,
  CanNotUpdateJournalStatus = 80,
  CanNotVoidProductTemplate = 81,
  ProductTemplateNameCanNotEmpty = 82,
  CanNotAddNewPriceToProductService = 83,
  ProductServicePriceNameDuplicated = 84,
  InvalidINetAuthenticationData = 85,
  AssetPurchaseDateLessThanStopAssetDepreciationDate = 86,
  PackageErrorCode = 87,
  UpgradeToPackageErrorCode = 88,
  AssetTemplateCodeDuplicated = 89,
  CanNotEditTransactionAsset = 90,
  CanNotVoidAssetTemplateBecauseAssetTemplateIssuedAsset = 91,
  CanNotVoidAssetBecauseAssetIssuedByPurchaseAsset = 92,
  CanNotVoidAssetBecauseAssetIssuedBySaleAsset = 93,
  OverLimitAsset = 94,
  BillingTransactionCurrencyNotCorrect = 95,
  DuplicatedReceiveBillingNoteNumber = 96,
  CanNotSaleAssetBecauseDoesNotSelectAssetId = 97,
  CanNotSaleAssetBecauseSaleAssetDateLessThanStopDepreciationDate = 98,
  IsNotHaveContactRevenueDepartment = 99,
  IsNotHaveContactSalary = 100,
  IsNotHaveContactSSO = 101,
  CantDoPaymentIsHaveErrorPndType = 102,
  CanNotVoidUnit = 103,
  ChequeIsReceivedAndChequeIsClearing = 104,
  ChartOfAccountCannotDeleted = 105,
  UserIsInSystemAlready = 106,
  UserNotFound = 107,
  InvitationIncorrect = 108,
  InvitationIncorrectOrExpired = 109,
  AssetTemplateIsDeleted = 110,
  OverCreditNoteAmount = 111,
  OverPaymentCreditNoteAmount = 112,
  CanNotCreateCreditNote = 113,
  CreditNoteDateLessThanReferenceTransactionDate = 114,
  CanNotVoidTransactionIsHaveReferenceDocumentPayment = 115,
  OverPaidReferenceDocumentPayment = 116,
  IsReferenceTransactionIssuedCreditNote = 117,
  IssueCreditNoteAmountOverReferenceCreditNote = 118,
  CannotVoidPaymentHavePND = 119,
  CanNotEditTransactionIsIssuedReferencePaymentDocument = 120,
  CanNotEditTransactionIsIssuedPayment = 121,
  CanNotCreateCreditNoteBecauseTransactionRefIsIssuedDebitNote = 122,
  CanNotCreateCreditNoteBecauseTransactionRefIsNoDebt = 123,
  CanNotCreateDebitNoteBecauseTransactionRefIsIssuedCreditNote = 124,
  CanNotGotReceiptBecauseNotHavePayment = 125,
  CanNotVoidBillingNoteBecausePaid = 126,
  BillingAmountCannotBeGreaterThanTheOutstandingBalanceOfTheDocument = 127,
  CanNotPaidPayment = 128,
  AccountingFirmDeleted = 129,
  NotHaveAfpRefCode = 130,
  AccountingFirmRegisted = 131,
  NotHaveAccountingFirmMerchant = 132,
  AccountingFirmMerchantDeleted = 133,
  InvalidPage365AuthenticationData = 134,
  DuplicatedSaleAsset = 135,
  ValidateProductMustHaveAccountId = 136,
  JournalModelNotFound = 137,
  JournalAccountDescriptionIsEmtryOrNull = 138,
  ValidateAssetMustHaveAccountId = 139,
  ProPlusRecurringTransaction = 140,
  ProBillingNote = 141,
  BankAccountNumberIsAllowDuplicate = 142,
  BasicCreateJournal = 143,
  InvalidBentoWebAuthenticationData = 144,
  NotHavePurchaseAccountAndSellAccountForProductTemplate = 145,
  InvalidLineMyShopAuthenticationData = 146,
  CanNotCreateCreditNoteBecauseReferenceTransactionTypeAsset = 147,
  CanNotCreateDebitNoteBecauseReferenceTransactionTypeAsset = 148,
  AccumulatedDepreciationMustBeLessThanassetvalue = 149,
  BookValueMustBeHigherThanScrapValue = 150,
  CanNotVoidPayment = 151,
  CanNotRedeemCode = 152,
  RedeemOnbordingPromoCodeNotFound = 153,
  CantDoPaymentIsHaveErrorDeductType = 154,
  CanNotUpdateBecauseImageNotFound = 155,
  CanNotUpdateBecauseBankReferenceNotFound = 156,
  CanNotUpdateBecauseBankNumberIsHaveError = 157,
  CanNotUpdateBecauseRemarkIsOverLength = 158,
  CanNotUpdateOnlineviewPaymentChannelSettingBecauseUserroleNotAdmin = 159,
  CanNotDeleteContact = 160,
  CanNotCreateOrUpdatePaymentBankStatement = 161,
  NotFoundPaymentBankStatement = 162,
  CanNotVoidOrDeletePaymentBankStatement = 163,
  UnableToMakeBankReconciled = 164,
  UnableCreateDefaultDataMerchantSample = 165,
  DemoMerchantExist = 166,
  ProductTemplateIsNotHaveVatType = 167,
  InvalidShopeeAuthenticationData = 168,
  CanNotSetDueDateBeforeTransactionDate = 169,
  UnableToUndoBankReconciled = 170,
  UnableToAprroveBankReconciled = 171,
  NotFoundBankReconciled = 172,
  CannotEditTransactionItemNotMap = 173,
  CanNotAssignContactGroup = 174,
  CannotEditPaymentBecausePaymentItemNotMap = 175,
  MerchantIsNotAllowDuplicateContactTaxId = 176,
  TaxInvoiceNumberDuplicated = 177,
  ProCanImportBankStatement = 178,
  ProCanReconcile = 179,
  CanNotEditContactTransactionIsReferenceInvoice = 180,
  CanNotEditContactTransactionIsReferenceReceipt = 181,
  CanNotEditContactTransactionIsIssuedBillingNote = 182,
  CanNotEditContactTransactionIsReferenceQuotation = 183,
  CanNotEditContactTransactionIsReferenceBillingNote = 184,
  ReconciledAlready = 185,
  CanNotVoidBecauseJournalAccountIsReconciled = 186,
  InvalidLazadaAuthenticationData = 187,
  MerchantDeleteAlReady = 188,
  MerchantNameNotEqual = 189,
  userIsNotAdmin = 190,
  InvalidLightworkAuthenticationData = 191,
  QRPaymentSettingModelNotFound = 192,
  SCBQRPaymentCodeModelNotFound = 193,
  CanNotVoidBankCauseByHaveBankInSCBQR = 194,
  FreePackageNotAllowedSelectChartOfAccount = 195,
  FreePackageProductIsHaveMaximum = 196,
  FreePackageCannotCreateNewFinanceAccount = 197,
  FreePackageCannotCreateNewAccount = 198,
  PackageNotFound = 199,
  CanNotCreateContactHaveMaximumContact = 200,
  CanNotCreateContactPersonHaveMaximum = 201,
  FreePackageNotAllowedAttachFile = 202,
  CanNotCreateDocumentsDatingBackUpToTwoMonths = 203,
  CanNotEditJounalBecauseFreePackage = 204,
  CantPaidPaymentSCBQRCauseByBankAccountNotFound = 205,
  CanNotIssuedTaxInvoiceNotVat = 206,
  CantPaidPaymentSCBQRCauseByAccountModelNotFound = 207,
  CantPaidPaymentSCBQRCauseByQRPaymentSettingModelNotFound = 208,
  CantPaidPaymentSCBQRCauseBySettingSCBPaymentCodeModelNotFound = 209,
  CantPaidPaymentSCBQRCauseByBankAccountNotSet = 210,
  TransactionNewStatusCannotLessThanCurrentStatus = 211,
  TransactionCurrentStatusCannotBeRejected = 212,
  CanNotCreateBecauseHaveRecordZeroAmount = 213,
  CanNotCreateBecauseNotSupportMultipleBankAccount = 214,
  CanNotEditRecordDeleted = 215,
  CanNotEditInvoiceBecauseDocumentHasBeenReferredToOtherDocument = 216,
  ContactPersonNamePrefixOtherMaxLength = 217,
  ContactNamePrefixOtherMaxLength = 218,
}

export enum AppConnectExceptionResponseCode {
  Success = 0,
  GeneralError = 1,
  AuthorizeError = 2,
  Page365Error = 3,
  BentoWebError = 4,
  LineMyShopError = 5,
  ShopeeError = 6,
  LazadaError = 7,
  SCB = 8,
  LightworkError = 9,
  MatchLinkError = 10,
  UserError = 11,
  MerchantError = 12,
  PaySolutionError = 13,
}

export enum MatchLinkErrorCode {
  None = 0,
  Default = 1,
  Unauthorize = 2,
  Claimed = 3,
  NotAcceptAgreement = 4,
  InvalidOrMissingVerificationData = 5,
}

export enum TaxIncomeType {
  None = 0,
  SalariesIncome = 1,
  SalariesIncomeHaveWithholdingTaxRate = 2,
  SeverancePay = 3,
  SalariesWorkingIncome = 4,
  GoodwillAndRightIncome = 5,
  InterestOrDiscountIncome = 6,
  ProfitSharingIncome = 7,
  BonusToShareholder = 8,
  PortionOfDecapitalized = 9,
  IncreasedCapital = 10,
  BenefitFromConsolidated = 11,
  BenefitFromTrade = 12,
  AssetRentalIncome = 13,
  ProfessionalServiceIncome = 14,
  ContractWorkIncome = 15,
  HireOfWorkIncome = 16,
  AdvertisingIncome = 17,
  PrizeOrRewardIncome = 18,
  OtherServicesExcludeHotelRestaurantAndInsurance = 19,
  DiscountOrTradePromotion = 20,
  Insurance = 21,
  NonPublicTransport = 22,
  CelebrityHiring = 23,
}

export enum WhtRateType {
  None = 0,
  Custom = 1,
  ZeroPointSevenFive = 2,
  OnePercent = 3,
  TwoPercent = 4,
  ThreePercent = 5,
  FivePercent = 6,
  TenPercent = 7,
  FifteenPercent = 8,
  OnePointFivePercent = 9,
}

export enum ModalCreateType {
  Basic = 1,
  Advance = 2,
}

export enum TaxInvoiceType {
  TaxInvoice = 0,
  CreditNote = 1,
  DebitNote = 2,
  NonTaxInvoice = 3,
}

export enum WhtCertificateTableViewStatusType {
  All = 0,
  Draft = 1,
  AwaitApproval = 2,
  AwaitFiling = 3,
  FiledTax = 4,
  Voided = 5,
}

export enum WhtCertificateType {
  Create = 1,
  Edit = 2,
  Preview = 3,
}

export enum PaymentFlowType {
  None = 0,
  CashIn = 1,
  CashOut = 2,
}

export enum SourceType {
  None = -1,
  PeakTax = 0,
  PeakAccount = 1,
  PeakPayRoll = 2,
}

export enum WhtCertificateStatus {
  Draft = -2,
  AwaitApproval = -1,
  AwaitFiling = 0,
  FiledTax = 1,
}

export enum ResponseCode {
  Success = 0,
  GeneralError = 1,
  AuthorizeError = 2,
  TransactionError = 3,
  WhtCerfiticateError = 4,
}

export enum TransactionTableViewStatusType {
  All = 0,
  AwaitFiling = 1,
  FiledTax = 2,
  Voided = 3,
}

export enum GetTaxIncomeTypeListType {
  All = 0,
  OrdinaryPerson = 1,
  JuristicPerson = 2,
  WHTCertItem401 = 3,
  WHTCertItem402 = 4,
  WHTCertItem403 = 5,
  WHTCertItem404A = 6,
  WHTCertItem40X1 = 7,
  WHTCertItem40X2 = 8,
  WHTCertItem40X3 = 9,
  WHTCertItemOther = 10,
}

export enum WHTCertItemType {
  WHTCertItem401 = 1,
  WHTCertItem402 = 2,
  WHTCertItem403 = 3,
  WHTCertItem404A = 4,
  WHTCertItem40X1 = 5,
  WHTCertItem40X2 = 6,
  WHTCertItem40X3 = 7,
  WHTCertItemOther = 8,
}

export enum ConditionType {
  None = 0,
  WithholdingTax = 1,
  LeaveForever = 2,
  LeaveOneTime = 3,
}

export enum CurrencyCode {
  THB = 0,
  USD = 1,
  GBP = 2,
  EUR = 3,
  JPY = 4,
  HKD = 5,
  MYR = 6,
  SGD = 7,
  BND = 8,
  PHP = 9,
  IDR = 10,
  INR = 11,
  CHF = 12,
  AUD = 13,
  NZD = 14,
  CAD = 15,
  SEK = 16,
  DKK = 17,
  NOK = 18,
  CNY = 19,
  MXN = 20,
  ZAR = 21,
  KRW = 22,
  TWD = 23,
  KWD = 24,
  SAR = 25,
  AED = 26,
  MMK = 27,
  BDT = 28,
  CZK = 29,
  KHR = 30,
  KES = 31,
  LAK = 32,
  RUB = 33,
  VND = 34,
  EGP = 35,
  PLN = 36,
  LKR = 37,
  IQD = 38,
  BHD = 39,
  OMR = 40,
  JOD = 41,
  QAR = 42,
  MVR = 43,
  NPR = 44,
  PGK = 45,
  ILS = 46,
  HUF = 47,
  PKR = 48,
}

export enum TransactionStatus {
  NotFiledTax = -3,
  AwaitFiling = 0,
  FiledTax = 1,
}

export enum CreateType {
  None = 0,
  SalesTax = 1,
  PurchaseTax = 2,
  WithHoldingTax = 3,
}

export enum PP30FormStatus {
  Draft = -2,
  AwaitApproval = -1,
  AwaitFiling = 0,
  Filed = 1,
}

export enum PndStatus {
  Draft = -2,
  AwaitApproval = -1,
  AwaitFiling = 0,
  Filed = 1,
}

export enum PP30TaxCreditType {
  None = 0,
  RefundTax = 1,
  CreditTax = 2,
  ExpenseTax = 3,
}

export enum PP30TaxRefundType {
  None = 0,
  Cash = 1,
  Bank = 2,
}

export enum PP30FilingRoundType {
  None = 0,
  WithInDue = 1,
  OverDue = 2,
}

export enum TransactionType {
  None = 0,
  Quotation = 1,
  Invoice = 2,
  Receipt = 3,
  TaxInvoice = 4,
  CreditNote = 5,
  BillingNote = 6,
  DebitNote = 7,
  PP30 = 8,
  Pnd53 = 9,
  Pnd3 = 10,
  DailyJournal = 11,
  WithholdingTax = 12,
  Payroll = 13,
  TaxPP30 = 14,
  TaxPND53 = 15,
  TaxPND3 = 16,
  Pnd1 = 17,
  Pnd2 = 18,
}

export enum TaxSourceType {
  PeakTax = 0,
  PeakAccount = 1,
  PeakPayRoll = 2,
}

export enum TaxDocumentType {
  None = 0,
  WithHoldingTax = 1,
  Pnd = 2,
  PP30Transaction = 3,
  PP30Form = 4,
}

export enum FiledType {
  None = 0,
  Document = 1,
  TextFile = 2,
  Api = 3,
}

export enum PP30FormTableViewStatusType {
  All = 0,
  Draft = 1,
  AwaitApproval = 2,
  AwaitFiling = 3,
  AwaitPayment = 4,
  Paid = 5,
  Voided = 6,
}

export enum PP30FormTableSortColumnType {
  Id = 0,
  PP30FormNumber = 1,
  PP30FormDate = 2,
}

export enum PndTableViewStatusType {
  All = 0,
  Draft = 1,
  AwaitApproval = 2,
  AwaitFiling = 3,
  AwaitPayment = 4,
  Paid = 5,
  Voided = 6,
}

export enum PndTableSortColumnType {
  Id = 0,
  PndNumber = 1,
  PndDate = 2,
}

export enum TransactionTableSortColumnType {
  Id = 0,
  TaxInvoiceNumber = 1,
  TaxInvoiceDate = 2,
}

export enum WhtCertificateTableSortColumnType {
  Id = 0,
  WhtCertificateNumber = 1,
  WhtCertificateDate = 2,
}

export enum VerifyType {
  Success = 1,
  Warn = 2,
  Fail = 3,
}

export enum ExceptionCode {
  Success = 0,
  GeneralError = 1,
  AuthorizeError = 2,
  TransactionError = 3,
  WhtCerfiticateError = 4,
  PndError = 5,
  PP30Error = 6,
}

export enum AuthorizeErrorCode {
  None = 0,
  Default = 1,
  UnauthorizeRole = 2,
}
export enum WhtCerfiticateErrorCode {
  None = 0,
  Default = 1,
  DuplicateNumber = 2,
  DataError = 3,
  CanNotEdit = 4,
  CanNotVoid = 5,
  DataNotFound = 6,
}
export enum TransactionErrorCode {
  None = 0,
  Default = 1,
  DuplicateNumber = 2,
  DataError = 3,
  CanNotEdit = 4,
  CanNotVoid = 5,
  DataNotFound = 6,
  TransactionTypeNotFound = 7,
  DataIsDuplicate = 8,
  NonTaxInvoiceMustDontHaveTax = 9,
  ContactNotFound = 10,
}
export enum PP30FormErrorCode {
  None = 0,
  Default = 1,
  DuplicateNumber = 2,
  DataError = 3,
  CanNotEdit = 4,
  CanNotVoid = 5,
  DataNotFound = 6,
  CreateJournalFailed = 7,
  CreateExpenseFailed = 8,
  CanNotFiling = 9,
  VoidJournalFailed = 10,
  VoidExpenseFailed = 11,
  DuplicateTransactionData = 12,
  CreateJournalFailedByRealtime = 13,
  VoidJournalFailedByRealtime = 14,
  CreateExpenseFailedByRealtime = 15,
  VoidExpenseFailedByRealtime = 16,
  CannotClosingLockPeriod = 17,
  CanNotVoidCauseByIsClosingEntry = 18,
  DataClosingEntryIsDuplicate = 19,
}
export enum PndErrorCode {
  None = 0,
  Default = 1,
  DuplicateNumber = 2,
  InsertHaveError = 3,
  DataError = 4,
  CanNotEdit = 5,
  CreateJournalFailed = 6,
  CreateExpenseFailed = 7,
  DataNotFound = 8,
  CanNotVoid = 9,
  CheckTheDataPositioningInTextFile = 10,
  VoidJournalFailed = 11,
  VoidExpenseFailed = 12,
  TransactionTypeNotFound = 13,
  DuplicateTransactionData = 14,
  CreateJournalFailedByRealtime = 15,
  VoidJournalFailedByRealtime = 16,
  CreateExpenseFailedByRealtime = 17,
  VoidExpenseFailedByRealtime = 18,
  CanNotVoidCauseByIsClosingEntry = 19,
  NumberInvalid = 20,
  DataClosingEntryIsDuplicate = 21,
}
export enum PeriodOptionType {
  None = 0,
  ThisMonth = 1,
  LastMonth = 2,
  ThisYear = 3,
  LastYear = 4,
  All = 5,
  Custom = 6,
}
export enum DatePeriodType {
  ThisMonth = 1,
  LastMonth = 2,
  ThisYear = 3,
  Lastyear = 4,
  Custom = 5,
}
export enum AdvancedSearchType {
  AdvanceSearch = 1,
  VeryAdvanceSearch = 2,
}
export enum TimelineStatusType {
  None = 0,
  Create = 1,
  Checked = 2,
  Disabled = 3,
  Active = 4,
}
export enum ModalCreatePP30TransactionType {
  None = 0,
  Create = 1,
  Edit = 2,
  EditForCreatePP30 = 3,
}
export enum CommentLogType {
  None = 0,
  Comment = 1,
  Log = 2,
}
/* eslint-disable @typescript-eslint/camelcase */
export enum NotificationMessageType {
  None = 0,
  Quotation = 1,
  PurcahseOrder = 2,
  Invoice = 3,
  InvoiceAllProduct = 4,
  Expense = 5,
  ExpenseAllProduct = 6,
  PurchaseAsset = 7,
  PurchaseAssetAllProduct = 8,
  Receipt = 9,
  StockActivityStockCardMovement = 10,
  TaxInvoice = 11,
  TaxInvoiceInRevenueDepartmentFormat = 12,
  TrialBalanceWithSubAccount = 13,
  TrialBalance = 14,
  PurcahseTaxInvoice = 15,
  PurchaseTaxInvoiceInRevenueDepartFormat = 16,
  Journal = 17,
  BillingNoteInvoice = 18,
  BillingNoteInvoiceAllInvoice = 19,
  BillingNoteExpense = 20,
  BillingNoteExpenseAllExpense = 21,
  Finance = 22,
  PP30InputVat = 23,
  PP30OutputVat = 24,
  CreditNote = 25,
  CreditNoteExpense = 26,
  AssetTemplateGroup = 27,
  AssetTemplate = 28,
  WithHeldTax = 29,
  WithHoldingTax = 30,
  GeneralLedgerTransaction = 31,
  AllGeneralLedger = 32,
  AllGeneralLedgerWithSubAccount = 33,
  AgingReportAR = 34,
  AgingReportAP = 35,
  Product = 36,
  ProfitLoss = 37,
  ChartOfAccount = 38,
  BalanceSheet = 39,
  Unit = 40,
  ReportDocument = 41,
  Asset = 42,
  StatementEFiling = 43,
  AllReport = 44,
  Contact = 45,
  PurchaseTaxInvoiceNotUse = 46,
  SalesTaxInvoiceNotUse = 47,
  PP30TaxFilingTextFile = 48,
  WithHoldingTaxPND2 = 49,
  WithHoldingTaxPND3 = 50,
  WithHoldingTaxPND53 = 51,
  CashflowStatementReport = 52,
  AllReportSalesByCustomerReport = 53,
  AllReportSalesByAccountReport = 54,
  AllReport_RemainingFinanceBalanceReport = 55,
  StatementEFilingExcel = 56,
  AllReportProductSalesByContact = 57,
  AllReport_ProductServiceSalesSummaryReportOnDailyAccount = 58,
  Pnd53TaxFilingTextFile = 59,
  Pnd3TaxFilingTextFile = 60,
  DailyJournal = 61,
  DocumentQuotation = 62,
  DocumentInvoice = 63,
  DocumentReceipt = 64,
  DocumentTaxInvoice = 65,
  DocumentPurchaseOrder = 66,
  DocumentExpense = 67,
  DocumentBillingNote = 68,
  DocumentBillingNoteExpense = 69,
  DocumentCreditNote = 70,
  DocumentCreditNoteExpense = 71,
  DocumentPurchaseTaxInvoice = 72,
  DocumentWithholdingTax = 73,
  ImportTransactionPurchaseInventory = 74,
  ImportTransactionExpense = 75,
  ImportTransactionInvoice = 76,
  ImportTransactionReceipt = 77,
  ImportTransactionQuotation = 78,
  ImportTransactionPurchaseOrder = 79,
  Statement = 80,
  AllReportWithHoldingTaxPND2 = 81,
  AllReportWithHoldingTaxPND3 = 82,
  AllReportWithHoldingTaxPND53 = 83,
  ChequeReport = 84,
  WorkingPaper = 85,
  RecalCostOfGoodSoldByMerchantCalculated = 86,
  RecalCostOfGoodSoldByProductCalculated = 87,
  RecalCostOfGoodSoldFailed = 88,
  DebitNote = 89,
  DocumentDebitNote = 90,
  DebitNoteExpense = 91,
  DocumentDebitNoteExpense = 92,
  VoidImportTransactionFailed = 93,
  TrialBalanceSeperateMonth = 94,
  VoidImportTransactionSuccess = 95,
  ImportTransactionReceiptFromInvoice = 96,
  ImportTransactionJournal = 97,
  DepreciateAssetMonthly = 98,
  TaxPnd = 99,
  TaxPP30SaleTax = 100,
  TaxPP30PurchaseTax = 101,
  TaxFetchPP30Transaction = 102,
  TaxFetchWhtCertificate = 103,
  AllReportPurchaseTaxInvoiceNotUseFromPeakTax = 104,
  AllReportSalesTaxInvoiceNotUseFromPeakTax = 105,
  AllReportTaxInvoiceFromPeakTax = 106,
  AllReportPurchaseTaxInvoiceFromPeakTax = 107,
  AllReportPurchaseTaxInvoiceNotUseFromOldPeak = 108,
  AllReportSalesTaxInvoiceNotUseFromOldPeak = 109,
  AllReportTaxInvoiceFromOldPeak = 110,
  AllReportPurchaseTaxInvoiceFromOldPeak = 111,
  FinanceBankStatement = 112,
  ExecutiveSummary = 113,
  StatementOfCashflow = 114,
  RecieveBenefit = 115,
  CamPaignBeforeExpire = 116,
  BeforeExpireByDate = 117,
  QuotaExpire = 118,
  ApprovedTransaction = 119,
  MentionTransaction = 120,
  RemovePeakSupport = 121,
  SendApprovedDocumentTransaction = 122,
}
export enum Position {
  None = -1,
  Other = 0,
  BusinessOwner = 1,
  Bookkeeper = 2,
  Salesperson = 3,
  Admin = 4,
  Accountant = 5,
  Employee = 6,
  AccountingFirm = 7,
  Student = 8,
}
export enum Department {
  None = -1,
  Other = 0,
  GeneralManagement = 1,
  GeneralAdministration = 2,
  Sales = 3,
  Marketing = 4,
  Accounting = 5,
  Finance = 6,
  HumanResource = 7,
  Production = 8,
  Operation = 9,
  InformationTechnology = 10,
  Purchasing = 11,
  ResearchAndDevelopment = 12,
  General = 13,
}

export enum PeakSource {
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
}

export enum UserRight {
  None = 0,
  ViewOnly = 1,
  RevenueExpenseDraftOnly = 2,
  RevenueExpenseApproveOnly = 3,
  RevenueAll = 4,
  ExpenseAll = 5,
  QuotationOnly = 6,
  Standard = 7,
  BasicAndAdmin = 8,
  CreateRevenueOnly = 9,
  CreateExpenseOnly = 10,
  PurchaseOrderOnly = 11,
  RevenueDraftOnly = 12,
  ExpenseDraftOnly = 13,
  RevenueApproveOnly = 14,
  ExpenseApproveOnly = 15,
  QuotationDraftOnly = 16,
  QuotationApproveOnly = 17,
  PurchaseOrderDraftOnly = 18,
  PurchaseOrderApproveOnly = 19,
  ExpenseExceptPOAll = 20,
  RevenueExceptQOAll = 21,
  RevenueExpenseExceptQOandPOApproveOnly = 22,
}

export enum UserOrderBy {
  Id = 1,
  DisplayName = 2,
  LastestLogin = 3,
}

export enum AuthorityRole {
  None = 0,
  ViewOnly = 1,
  PartialRights = 2,
  StandardRights = 3,
  Admin = 4,
}

export enum UserRightSetting {
  ViewOnly = 1,
  Partial = 2,
  Basic = 3,
  Admin = 4,
}

export enum PartialRightType {
  DraftOnly = 1,
  ApproveAndPaymentOnly = 2,
  RevenueOnly = 3,
  ExpenseOnly = 4,
  QuotationOnly = 5,
  CreateRevenueOnly = 6,
  CreateExpenseOnly = 7,
}

export enum BasicRightType {
  CanViewExport = 1,
  ConNotViewExport = 2,
}

export enum InvitationType {
  InviteUser = 0,
  InviteUserToMerchant = 1,
}

export enum OrdinalNumbers {
  First = "1st",
  Second = "2nd",
  Third = "3rd",
  Fourth = "4th",
  Fifth = "5th",
  Sixth = "6th",
  Seventh = "7th",
  Eighth = "8th",
  Ninth = "9th",
  Tenth = "10th",
}

export enum RouterAction {
  Create = "ca",
  FetchData = "fd",
}

export enum FavoriteType {
  None = 0,
  WhtCertificate = 1,
  SalesTax = 2,
  PurchaseTax = 3,
}
export enum ActivityLogSource {
  None = 0,
  PEAK_Engine = 1,
  PEAK_Experience = 2,
  PEAK_API = 3,
  TransactionImport = 4,
  ZORT = 5,
  KetShopWeb = 6,
  XCommerce = 7,
  BentoWeb = 8,
  Wisible = 9,
  Empeo = 10,
  Recurring = 11,
  BoxMe = 12,
  PeakAsset = 13,
  LineConnect = 14,
  UCommerce = 15,
  Page365 = 16,
  PeakPayroll = 17,
  PeakBoard = 18,
  PeakTax = 19,
}
export enum FinanceAndAccountRights {
  None = 0,
  All = 1,
  FinanceAccessOnly = 2,
  GLAndStatementOnly = 3,
  DailyJournalsAll = 4,
  DailyJournalsDraftOnly = 5,
  DailyJournalsApproveOnly = 6,
  DailyJournalsAllAndFinance = 7,
  DailyJournalsDraftOnlyAndFinance = 8,
  DailyJournalsApproveOnlyAndFinance = 9,
  DailyJournalsAllAndGL = 10,
  DailyJournalsDraftOnlyAndGL = 11,
  DailyJournalsApproveOnlyAndGL = 12,
  FinanceAccountAndDailyJournalsDraftOnly = 13,
  FinanceAccountAndDailyJournalsApproveOnly = 14,
  FinanceAndGL = 15,
}
export enum DailyJournalsRightType {
  None = 0,
  DraftOnly = 1,
  ApproveOnly = 2,
  All = 3,
}
export enum ContactUserRoleType {
  None = 0,
  All = 1,
  ContactAccessAndAddContact = 2,
  ContactAccessAndEditContact = 3,
  ContactAccessAndDeleteContact = 4,
  ContactAccessAndExportContact = 5,
  ContactAccessAddAndEditContact = 6,
  ContactAccessAddAndDeleteContact = 7,
  ContactAccessAddAndExportContact = 8,
  ContactAccessEditAndDeleteContact = 9,
  ContactAccessEditAndExportContact = 10,
  ContactAccessDeleteAndExportContact = 11,
  AddAndEditContact = 12,
  AddAndDeleteContact = 13,
  AddAndExportContact = 14,
  AddEditAndDeleteContact = 15,
  AddEditAndExportContact = 16,
  AddDeleteAndExportContact = 17,
  EditAndDeleteContact = 18,
  EditAndExportContact = 19,
  AddEditDeleteAndExportContact = 20,
  DeleteAndExportContact = 21,
  DeleteExportAndEditContact = 22,
  ContactAccess = 23,
  AddContact = 24,
  EditContact = 25,
  DeleteContact = 26,
  ExportContact = 27,
  ContactAccessAddEditAndDeleteContact = 28,
  ContactAccessAddEditAndExportContact = 29,
  ContactAccessAddDeleteAndExportContact = 30,
  ContactAccessEditDeleteAndExportContact = 31,
}
export enum SourceTypeProject {
  PeakMini = 0,
  PeakExperience = 1,
  PeakApi = 2,
  PeakTax = 3,
  LineConnect = 4,
  PeakPayroll = 5,
  PeakAdmin = 6,
  PeakAsset = 7,
  FileVault = 8,
}
export enum VideoFeedback {
  None = 0,
  Yes = 1,
  No = 2,
  Complete = 3,
  Submit = 4,
}

export enum BroadcastUserChannelType {
  None = 0,
  AuthenticatedNotification = 1,
  DisconnectNotification = 2,
  UpdateNotificationList = 3,
  MasterDeleteNotificationById = 4,
  UpdateNotificationCount = 5,
  MasterGetNotificationListByMerchantId = 6,
  MasterGetNotificationCountByMerchantId = 7,
  DisconnectNotificationAllTab = 8,
  ReCreateTab = 9,
  MasterSetNotificationIsSeenAll = 10,
  UpdateUnSeenNotificationList = 11,
  UpdateIsSeenNotificationList = 12,
  MasterGetUnSeenNotificationListByMerchantId = 13,
  MasterGetIsSeenNotificationListByMerchantId = 14,
  MasterSetNotificationIsSeenById = 15,
  UpdateIsSeenNotificationFromActionIsSeen = 16,
}

export enum AuthenticatedNotification {
  Success = 1,
  Failed = 2,
}

export enum BroadcastTabChannelType {
  None = 0,
  MasterTabClose = 1,
}

export enum NotificationType {
  None = 0,
  System = 1,
  Download = 2,
  Mention = 3,
}

export enum TransactionItemType {
  None = 0,
  Service = 1,
  Inventory = 2,
  Asset = 3,
}
